const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/initialValues.ts';
import { normalizePhoneNumber } from 'App/utils/phoneNumberUtils';
import { usePatientData } from 'App/store/patient';
import { useSelector } from 'react-redux';
import { useArbeitgeberData } from 'App/store/arbeitgeber';
import { selectUserDetailsFromRegisterWorkItem } from 'App/store/login';
import { useCaseData } from 'App/store/case';
import { getArztDataFromCase } from 'App/utils/cases';

export const useECheckinInitialValues = (fallNr?: string) => {
    const [pat, patientIsLoading] = usePatientData();
    const loginDetails = useSelector(selectUserDetailsFromRegisterWorkItem);
    const [arbeitgeberInfos] = useArbeitgeberData();

    const [caseData, caseDataIsLoading] = fallNr ? useCaseData(fallNr) : [undefined, false];
    const hausArztData = getArztDataFromCase(caseData, 'HausAz');

    const isLoading = patientIsLoading || caseDataIsLoading;

    const patFirstName = pat.get('VORNAME') ?? loginDetails?.get('firstname') ?? '';
    const patLastName = pat.get('NAME') ?? loginDetails?.get('lastname') ?? '';

    const persAngaben = {
        firstname: patFirstName,
        lastname: patLastName,
        geschlecht: pat.get('SEX') ?? '',
        dateOfBirth: (pat.get('GEBDAT') || '').slice(0, 10), // YYYY-MM-DD
        tel: normalizePhoneNumber(pat.get('TELEFON') || pat.get('TELEFON_G')),
        mobile: normalizePhoneNumber(pat.get('TELEFON_M') || loginDetails?.get('mobile')),
        nationality: pat.get('NATIONALITAET') ?? '',
        zivilstand: pat.get('ZIVILSTAND') ?? '',
        ahv: pat.get('SOZVERSNR') ?? '',
        religion: pat.get('KONFESSION') ?? '',
        email: (loginDetails?.get('email') || pat.get('EMAIL')) ?? '',
    };

    const wohnsitz = {
        streetAndNumber: pat.get('STRASSE') ?? '',
        plz: pat.get('PLZ') ?? '',
        ort: pat.get('ORT') ?? '',
        country: pat.get('LAND') ?? '',
    };

    const arbeitgeber = arbeitgeberInfos?.size
        ? {
              employment: 'employed',
              company: arbeitgeberInfos?.get('Name') ?? '',
              streetAndNumber: arbeitgeberInfos?.get('Strasse') ?? '',
              plz: arbeitgeberInfos?.get('PLZ') ?? '',
              ort: arbeitgeberInfos?.get('Ort') ?? '',
              country: arbeitgeberInfos?.get('Land') ?? '',
              tel: normalizePhoneNumber(arbeitgeberInfos?.get('Tel')),
          }
        : {};

    const einwArzt = hausArztData
        ? {
              firstname: hausArztData.Vorname,
              lastname: hausArztData.Name,
              streetAndNumber: hausArztData.Strasse,
              ort: hausArztData.Ort,
              plz: hausArztData.PLZ,
              country: hausArztData.Land,
              tel: normalizePhoneNumber(hausArztData?.Tel),
              key: hausArztData.OBJECTKEY,
          }
        : {};

    return [{ persAngaben, arbeitgeber, einwArzt, wohnsitz }, isLoading];
};
